<template lang="pug">
  section(id="smi")
     .goscontainer
        v-container
          .heading СМИ  о платформе:

     .goscontainer
        v-row(no-gutters)
            v-col.col( v-for="(digest, i) in digests"
                   :key="i"
                   cols="12"
                   md="4")
                div.head {{digest.smi}}
                div.date {{digest.date}}
                div.text {{digest.text}}
                div.link 
                  a(:href="digest.link") Читать в первоисточнике

        router-link.text-center.mt-2.all(to="/page/sp_digest" v-if="$_sms_isAvailable") Читать все отзывы и комментарии
            
</template>

<script>
  export default {
    name: 'SectionSmi',
    data: () => ({
      digests: [
        {
          smi: 'РАПСИ',
          date: '27.05.2020',
          text: 'Впервые в Петербурге прошло онлайн-заседание с помощью платформы "Судебный портал"',
          link: 'http://rapsinews.ru/judicial_news/20200527/305852599.html'
        },
        {
          smi: 'Интерфакс',
          date: '09.06.2020',
          text: 'Суд в Петербурге начнет рассматривать дело историка Соколова, обвиняемого в убийстве. Из-за ситуации с коронавирусом в суды города временно запрещен доступ слушателей. Как сообщила объединенная пресс-служба судов города, будет организована видеотрансляция процесса в онлайн-системе "Судебный портал".',
          link: 'https://www.interfax.ru/russia/712396'
        },
        {
          smi: 'Кубанские новости',
          date: '15.09.2020',
          text: 'В Краснодарском крае принять участие в судебном процессе можно, не выходя из дома',
          link: 'https://kubnews.ru/obshchestvo/2020/09/15/v-krasnodarskom-krae-prinyat-uchastie-v-sudebnom-protsesse-mozhno-ne-vykhodya-iz-doma-/'
        }
      ]
    }),
    computed: {
      $_sms_isAvailable () {
        return window.settings.cms && window.settings.cms.available==true
      }
    }
  }
</script>

<style lang="sass" scoped>
  #smi
    padding: 16px 16px 48px 16px
    background-color: #FFFFFF
    color: #505254
    .heading 
        font-family: $slab
        font-weight: 300
        font-size: 32px
        margin-bottom: 8px
        color:#505254
    .col
        background: #F3F3F3
        border-left: 8px solid #FFFFFF
        padding: 29px 34px
        margin-bottom: 8px
        font-size: 14px
        .head, .date 
            font-size: 18px
        .text 
            margin: 32px 0 24px 0
            font-style: italic
        .link a
            color: #0E9DBC
            font-style: italic
            text-decoration: none
    .all
        font-family: $slab
        font-weight: 300
        display: block
        color: #0E9DBC
        text-decoration: none
</style>
